import { apiClient } from 'common/clients/api.client';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants';
import { EApiPathParams } from 'common/enums/api-path-params.enum';
import {
  TIssueBurnEmissionReqParams,
  TIssueBurnEmissionResData,
  TEmissionHistoryResData, TEmissionHistoryReqParams,
} from '../types/emission.types';

export const issueEmissionService = async (
  counterpartyGuid: string,
  params: TIssueBurnEmissionReqParams
): Promise<TIssueBurnEmissionResData> => {
  const url = API_ENDPOINTS.EMISSION.COUNTERPARTY_EMISSION_ISSUE
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const res = await apiClient.post<TIssueBurnEmissionResData>(url, params);

  return res.data;
};

export const burnEmissionService = async (
  counterpartyGuid: string,
  params: TIssueBurnEmissionReqParams
): Promise<TIssueBurnEmissionResData> => {
  const url = API_ENDPOINTS.EMISSION.COUNTERPARTY_EMISSION_BURN
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const res = await apiClient.post<TIssueBurnEmissionResData>(url, params);

  return res.data;
};

export const setAdminEmissionCancelService = async (
  assetHistoryRecordGUID: string,
): Promise<{}> => {
  const url = API_ENDPOINTS.EMISSION.ADMIN_COUNTERPARTY_EMISSION_CANCEL
    .replace(EApiPathParams.AssetsHistoryRecordGuid, assetHistoryRecordGUID);
  const res = await apiClient.post<TEmissionHistoryResData>(url);

  return res.data;
};

export const setAdminEmissionConfirmService = async (
  assetHistoryRecordGUID: string,
): Promise<{}> => {
  const url = API_ENDPOINTS.EMISSION.ADMIN_COUNTERPARTY_EMISSION_CONFIRM
    .replace(EApiPathParams.AssetsHistoryRecordGuid, assetHistoryRecordGUID);
  const res = await apiClient.post<TEmissionHistoryResData>(url);

  return res.data;
};

export const getAdminEmissionHistoryService = async (
  counterpartyGuid: string,
  params?: TEmissionHistoryReqParams
): Promise<TEmissionHistoryResData> => {
  const url = API_ENDPOINTS.EMISSION.ADMIN_COUNTERPARTY_EMISSION_HISTORY;
  const config = {
    params,
  };
  const res = await apiClient.get<TEmissionHistoryResData>(url, config);

  return res.data;
};

export const getEmissionHistoryService = async (
  counterpartyGuid: string,
  params?: TEmissionHistoryReqParams
): Promise<TEmissionHistoryResData> => {
  const url = API_ENDPOINTS.EMISSION.COUNTERPARTY_EMISSION_HISTORY
    .replace(EApiPathParams.CounterpartyGuid, counterpartyGuid);
  const config = {
    params,
  };
  const res = await apiClient.get<TEmissionHistoryResData>(url, config);

  return res.data;
};
